import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1129.41176,1242.35294 L1129.41176,1355.29412 L338.823529,1355.29412 L338.823529,1242.35294 L1129.41176,1242.35294 Z M1581.17647,903.529412 L1581.17647,1016.47059 L338.823529,1016.47059 L338.823529,903.529412 L1581.17647,903.529412 Z M621.176471,0 C714.578824,0 790.588235,76.0094118 790.588235,169.411765 C790.588235,195.501176 784.150588,219.896471 773.647059,242.032941 L999.981176,468.254118 L920.018824,548.216471 L693.797647,321.882353 C671.661176,332.385882 647.152941,338.823529 621.176471,338.823529 C527.774118,338.823529 451.764706,262.814118 451.764706,169.411765 C451.764706,76.0094118 527.774118,0 621.176471,0 Z M344.470588,225.882353 C370.447059,354.635294 484.517647,451.764706 621.176471,451.764706 C634.729412,451.764706 648.282353,450.635294 660.705882,448.376471 L660.705882,448.376471 L920.470588,708.141176 L1159.90588,468.705882 L917.082353,225.882353 L1920,225.882353 L1920,1355.29412 L1355.29412,1355.29412 L1355.29412,1920 L5.68434189e-14,1920 L5.68434189e-14,225.882353 Z M1912.65882,1468.24659 L1468.23529,1912.55718 L1468.23529,1468.24659 L1912.65882,1468.24659 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNoteLightSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconNoteLightSolid, _Component);

  var _super = _createSuper(IconNoteLightSolid);

  function IconNoteLightSolid() {
    _classCallCheck(this, IconNoteLightSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconNoteLightSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('<IconNoteLightSolid /> is deprecated. Please use <IconNoteSolid /> instead.');
      }

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNoteLight",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconNoteLightSolid.displayName = "IconNoteLightSolid";
  return IconNoteLightSolid;
}(Component);

IconNoteLightSolid.glyphName = 'note-light';
IconNoteLightSolid.variant = 'Solid';
IconNoteLightSolid.deprecated = true;
IconNoteLightSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNoteLightSolid;
export { IconNoteLightSolid };